import { Component, Input } from '@angular/core';

/**
 * The Rotary gear wheel from the chapter logo (src/assets/images/rmbf-bbc-logo.png),
 * redrawn as a single-color inline SVG and spun via CSS animation - used as this app's
 * loading indicator (see LoadingScreenComponent) in place of the previous
 * `environment.erpLoadingUrl` (`assets/images/loading.gif`), a file that was never
 * actually added to assets/images - the global loading overlay's backdrop/positioning
 * (styles/styles.scss `.loading-screen`) rendered correctly, but its `<img>` content
 * was a permanently broken image.
 *
 * Redrawn rather than cropped from the raster logo so it can be recolored via
 * `[color]` and rotated smoothly at any size without JPEG/PNG edge artifacts - the
 * logo file itself is a fixed-size lockup (wordmark + wheel + RMBF badge), not an
 * isolated wheel asset.
 */
@Component({
  selector: 'app-rotary-spinner',
  standalone: false,
  templateUrl: './rotary-spinner.component.html',
  styleUrl: './rotary-spinner.component.scss'
})
export class RotarySpinnerComponent {
  /** Rendered width/height in pixels - the SVG's viewBox is square. */
  @Input() size = 88;

  /** Defaults to the logo's own gold, sampled from rmbf-bbc-logo.png. */
  @Input() color = '#EFA23C';
}
